import t from "./_baseGetTag.js";
import e from "./isObjectLike.js";
var s = "[object Arguments]";
function m(r) {
  return e(r) && t(r) == s;
}
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseIsArguments.js
// module id = 1472
// module chunks = 67